import { PhoneNumber } from 'lib-shared-legacy-types';
import { Component } from 'react';

import NumberItem from '../../topbar/telephony/components/items/NumberItem';
type PropsT = {
  selectingDefault: boolean | null;
  selectedFromNumber: any;
  dynamicTelephoneNumbersArray: Array<any>;
  changeFromNumber: (payload: any) => void;
  onToggle: (isOpen: boolean) => void;
};

export default class SimpleListNumbers extends Component<PropsT> {
  constructor(props: PropsT) {
    super(props);
  }

  changeFromNumber = (fromNumber: string | null) => {
    this.props.changeFromNumber(fromNumber);
  };

  render() {
    const listNumber = (number: PhoneNumber, index: number) => {
      let className = 'disabled';
      let disabled = true;

      if (
        number.incoming_functionality === true ||
        number.incoming_verified === true
      ) {
        disabled = false;
        className = '';
      }
      if (number.outgoing_functionality) {
        disabled = false;
        className = '';
        if (
          this.props.dynamicTelephoneNumbersArray &&
          this.props.dynamicTelephoneNumbersArray.length === 1
        ) {
          className += ' active';
        }
      }
      if (
        this.props.selectedFromNumber &&
        this.props.selectedFromNumber === number.e164_format
      ) {
        className += ' active';
      }
      if (
        this.props.selectingDefault &&
        number.outgoing_functionality === false
      ) {
        disabled = true;
        className = 'disabled';
      }
      return (
        <NumberItem
          key={index}
          index={index}
          disabled={disabled}
          className={className}
          changeFromNumber={this.changeFromNumber}
          number={number}
        />
      );
    };

    return (
      <div>
        {this.props.dynamicTelephoneNumbersArray &&
          this.props.dynamicTelephoneNumbersArray.map(listNumber)}
      </div>
    );
  }
}
